export default {
    REQUEST_AUTH_CODE_VERIFICATION: "REQUEST_AUTH_CODE_VERIFICATION",
    REQUEST_AUTH_CODE_VERIFICATION_SUCCESS: "REQUEST_AUTH_CODE_VERIFICATION_SUCCESS",
    REQUEST_AUTH_CODE_VERIFICATION_FAILED: "REQUEST_AUTH_CODE_VERIFICATION_FAILED"
};
